import React from 'react';
import { PMenuIconProps, useMenuIcon } from './useMenuIcon';

export const FolderIco: React.FC<PMenuIconProps> = (props) => {
  const { currentColor, classes } = useMenuIcon(props);
  return (
    <svg
      className={classes.ico}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.3633 24.7266C26.2189 24.7266 25.2525 25.4636 24.8885 26.4844H17.4748C17.2093 25.7398 16.6235 25.154 15.8789 24.8885V22.8516H14.1211V24.8885C13.3765 25.154 12.7907 25.7398 12.5252 26.4844H5.11154C4.7475 25.4636 3.78105 24.7266 2.63672 24.7266C1.18277 24.7266 0 25.9093 0 27.3633C0 28.8172 1.18277 30 2.63672 30C3.78105 30 4.7475 29.263 5.11154 28.2422H12.5252C12.8892 29.263 13.8557 30 15 30C16.1443 30 17.1108 29.263 17.4748 28.2422H24.8885C25.2525 29.263 26.2189 30 27.3633 30C28.8172 30 30 28.8172 30 27.3633C30 25.9093 28.8172 24.7266 27.3633 24.7266Z"
        fill={currentColor}
      />
      <path
        d="M25.5469 0H19.7825C18.6461 0 17.641 0.724394 17.2813 1.80246C17.2813 1.80246 17.2813 1.80246 17.2805 1.80246L16.3252 4.67262C16.205 5.03227 15.8695 5.27344 15.491 5.27344H2.69531C2.20951 5.27344 1.81641 5.66654 1.81641 6.15234V18.457C1.81641 19.911 2.99918 21.0938 4.45312 21.0938H25.5469C27.0008 21.0938 28.1836 19.911 28.1836 18.457V2.63672C28.1836 1.18277 27.0008 0 25.5469 0ZM23.7891 17.5781H20.2734C19.7876 17.5781 19.3945 17.185 19.3945 16.6992C19.3945 16.2134 19.7876 15.8203 20.2734 15.8203H23.7891C24.2749 15.8203 24.668 16.2134 24.668 16.6992C24.668 17.185 24.2749 17.5781 23.7891 17.5781ZM23.7891 14.0625H20.2734C19.7876 14.0625 19.3945 13.6694 19.3945 13.1836C19.3945 12.6978 19.7876 12.3047 20.2734 12.3047H23.7891C24.2749 12.3047 24.668 12.6978 24.668 13.1836C24.668 13.6694 24.2749 14.0625 23.7891 14.0625Z"
        fill={currentColor}
      />
      <path
        d="M4.45334 1.75781C3.309 1.75781 2.34256 2.4948 1.97852 3.51562H14.8577L15.4437 1.75781H4.45334Z"
        fill={currentColor}
      />
    </svg>
  );
};
